export default __webpack_public_path__ + "static/media/hht1_ep13_minisitcom_02.ad566584.png";